// extracted by mini-css-extract-plugin
export default {"link":"TeamBuilder_link__U-HyA"};